import {
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
  DialogTitle,
  DialogClose,
} from "../shadcn/dialog";
import { Button } from "../shadcn/Button";

interface TextModalProps {
  title: string;
  text: string | string[];
  showModal: boolean;
  onClose: () => void;
}

export default function TextModal({
  title,
  text,
  showModal,
  onClose,
}: TextModalProps) {
  return (
    <Dialog open={showModal} onOpenChange={onClose}>
      <DialogContent
        className="grid gap-2 text-white"
        aria-describedby={undefined}
      >
        <DialogHeader className="grid text-white">
          <DialogTitle className="scroll-m-20 pb-2 text-2xl font-semibold tracking-tight first:mt-0">
            {title}
          </DialogTitle>
        </DialogHeader>
        {typeof text === "string" && (
          <span className="leading-7 [&:not(:first-child)]:mt-4">{text}</span>
        )}
        {Array.isArray(text) &&
          text.map((t) => (
            <span key={t} className="leading-7 [&:not(:first-child)]:mt-4">
              {t}
            </span>
          ))}
        <DialogFooter>
          <DialogClose asChild>
            <Button className="w-full">Ok</Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
